// src/features/properties/PropertyModal.js
import { Modal, Button, Carousel, Spinner } from 'react-bootstrap'
import useAuth from '../../hooks/useAuth'
import { useState, useEffect } from 'react'
import PropertyEditForm from './PropertyEditForm'
import toast from 'react-hot-toast'
import { useDeletePropertyMutation, useTempDeletePropertyMutation } from './PropertiesApiSlice'
import { useGetCurrentUserQuery, useConsumePhoneViewMutation } from '../users/usersApiSlice'
import CloudinaryImage from '../utils/CloudinaryImage';
import getPublicId from '../utils/getPublicId';
import { useGetPropertyActivityLogsQuery } from './PropertiesApiSlice';

const PropertyModal = ({ property, show, onHide, onDuplicateFound }) => {
    const { isAdmin } = useAuth()
    const [mode, setMode] = useState('detail') // 'detail' hoặc 'edit'
    const [showAllPhones, setShowAllPhones] = useState(false)
    const [showLogModal, setShowLogModal] = useState(false);
    const [logPage, setLogPage] = useState(1);

    const {
        data: logData,
        isLoading: logLoading,
        isFetching: logFetching,
        refetch
    } = useGetPropertyActivityLogsQuery(
        { propertyId: property._id, page: logPage },
        { 
            skip: !showLogModal,
            refetchOnMountOrArgChange: true,
        },
    );

    const getActionBadgeClass = (action) => {
        if (action === 'VIEW_PHONE')          return 'bg-warning text-dark';
        if (action === 'CREATE_PROPERTY')     return 'bg-success text-white';
        if (action === 'UPDATE_PROPERTY')     return 'bg-info text-white';
        if (action === 'DELETE_PROPERTY')     return 'bg-danger text-white';
        if (action === 'TEMP_DELETE_PROPERTY') return 'bg-secondary text-white';
        if (action === 'RECOVER_PROPERTY')    return 'bg-primary text-white';
        return 'bg-dark text-white';
    };

    const getActionDisplayName = (action) => {
        const map = {
            VIEW_PHONE: 'Xem SĐT',
            CREATE_PROPERTY: 'Tạo BĐS',
            UPDATE_PROPERTY: 'Cập nhật BĐS',
            DELETE_PROPERTY: 'Xóa vĩnh viễn',
            TEMP_DELETE_PROPERTY: 'Xóa tạm',
            RECOVER_PROPERTY: 'Khôi phục',
        };
        return map[action] || action;
    };

    const renderLogDetails = (log) => {
        const d = log.details || {};
        let content = [];

        // if (d.phone) content.push(`SĐT: ${d.phone}`);
        // if (d.address) content.push(`Địa chỉ: ${d.address}`);
        // if (d.summary) content.push(d.summary);

        if (log.action === 'UPDATE_PROPERTY' && d.changes?.length) {
            content.push(...d.changes.map((ch, i) => <div key={i}>• {ch}</div>));
        }

        // return content.length ? content : <span className="text-muted">Không có chi tiết</span>;
        return content;
    };


    /* LẤY USER + QUOTA TỰ ĐỘNG */
    const {
        data: currentUser,
        isLoading: quotaLoading,
        isSuccess: quotaSuccess,
        refetch: refetchQuota
    } = useGetCurrentUserQuery(undefined, {
        skip: !show, // chỉ gọi khi modal mở
        refetchOnMountOrArgChange: true
    })

    const [consumePhoneView, { isLoading: isConsuming }] = useConsumePhoneViewMutation()
    const [deleteProperty, { isLoading: isDeleting }] = useDeletePropertyMutation()
    const [tempDeleteProperty, { isLoading: isTempDeleting }] = useTempDeletePropertyMutation()
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    const [showTempDeleteConfirm, setShowTempDeleteConfirm] = useState(false)

    /* RESET TRẠNG THÁI KHI MỞ MODAL */
    useEffect(() => {
        if (show) {
            setMode('detail')
            setShowAllPhones(false)
            refetchQuota() // đảm bảo lấy quota mới nhất
        }
    }, [show, property?._id, refetchQuota])

    if (!property) return null

    // Helper ẩn SĐT
    const maskPhone = (phone) => phone.replace(/(\d{4})\d{3}(\d{3})/, '$1xxx$2')

    // Khi người dùng click "mắt" để xem SĐT
    const handleShowPhone = async () => {
        if (showAllPhones) return
        // if (isAdmin) return setShowAllPhones(true)

        if (quotaLoading) return
        if (!currentUser) {
            toast.error('Không thể tải thông tin lượt xem')
            return
        }

        const quota = currentUser.phoneViewQuota ?? 0

        if (quota <= 0) {
            toast.error('Bạn đã hết lượt xem SĐT hôm nay! Vui lòng liên hệ Admin.')
            return
        }

        try {
            const result = await consumePhoneView({
                propertyId: property._id,
                phone: property.phone || []
            }).unwrap()
            setShowAllPhones(true)
            refetchQuota() 
            toast.success(`Đã dùng 1 lượt. Còn lại: ${result.remaining} lượt`)
        } catch (err) {
            toast.error(err?.data?.message || 'Không thể xem SĐT lúc này')
        }
    }
    
    // const renderPhones = () => {
    //     const phones = property.phone || []
    //     if (phones.length === 0)
    //         return <span className="text-light">Chưa có SĐT</span>

    //     const maskedPhones = phones.map(p => maskPhone(p)).join(', ')

    //     const quota = currentUser?.phoneViewQuota ?? 0

    //     return (
    //         <div className="d-flex flex-column">

    //             {/* DÒNG 1: SĐT */}
    //             <div className="d-flex">
    //                 {/* Cột trái: label */}
    //                 <strong className="me-2">SĐT:</strong>

    //                 {/* Cột phải: giá trị + icon */}
    //                 <div className="d-flex align-items-center flex-grow-1">
    //                     <span className="text-warning fw-bold">
    //                         {showAllPhones ? phones.join(', ') : maskedPhones}
    //                     </span>

    //                     {!showAllPhones && (
    //                         <button
    //                             type="button"
    //                             className="btn btn-link text-warning p-0 ms-2"
    //                             onClick={handleShowPhone}
    //                             disabled={isConsuming || (!isAdmin && quota === 0)}
    //                         >
    //                             {isConsuming ? (
    //                                 <Spinner animation="border" size="sm" />
    //                             ) : (
    //                                 <i className="bi bi-eye"></i>
    //                             )}
    //                         </button>
    //                     )}

    //                     {showAllPhones && (
    //                         <i className="bi bi-eye-fill text-success ms-2"></i>
    //                     )}
    //                 </div>
    //             </div>

    //             {/* DÒNG 2: LƯỢT XEM */}
                
    //             {
    //                 !isAdmin && currentUser?.phoneViewQuota === 0 && (
    //                     <div className="alert alert-danger py-2 px-3 mt-3 d-flex align-items-center gap-2" role="alert">
    //                         <div>
    //                             <i className="bi bi-exclamation-triangle-fill"></i> {' '}
    //                             <strong>Hết lượt xem SĐT hôm nay!</strong><br/>
    //                             <small>Vui lòng liên hệ Admin.</small>
    //                         </div>
    //                     </div>
    //                 )
    //             }


    //         </div>
    //     )
    // }

    const renderPhones = () => {
        // Bảo vệ: đảm bảo phones luôn là array
        const phones = Array.isArray(property.phone) ? property.phone : []
        
        if (phones.length === 0) {
            return <span className="text-light">Chưa có SĐT</span>
        }

        // Bảo vệ thêm: chỉ map nếu p là string hợp lệ
        const maskedPhones = phones
            .filter(p => typeof p === 'string' && p.trim()) // loại bỏ undefined/null/rỗng
            .map(p => maskPhone(p))
            .join(', ')

        // Nếu sau filter vẫn rỗng
        if (!maskedPhones) {
            return <span className="text-light">SĐT không hợp lệ</span>
        }

        const quota = currentUser?.phoneViewQuota ?? 0

        return (
            <div className="d-flex flex-column">
                <div className="d-flex">
                    <strong className="me-2">SĐT:</strong>
                    <div className="d-flex align-items-center flex-grow-1">
                        <span className="text-warning fw-bold">
                            {showAllPhones ? phones.join(', ') : maskedPhones}
                        </span>

                        {!showAllPhones && (
                            <button
                                type="button"
                                className="btn btn-link text-warning p-0 ms-2"
                                onClick={handleShowPhone}
                                disabled={isConsuming || (!isAdmin && quota === 0)}
                            >
                                {isConsuming ? (
                                    <Spinner animation="border" size="sm" />
                                ) : (
                                    <i className="bi bi-eye"></i>
                                )}
                            </button>
                        )}

                        {showAllPhones && (
                            <i className="bi bi-eye-fill text-success ms-2"></i>
                        )}
                    </div>
                </div>

                {/* Phần quota giữ nguyên */}
                {!isAdmin && currentUser?.phoneViewQuota === 0 && (
                    <div className="alert alert-danger py-2 px-3 mt-3 d-flex align-items-center gap-2" role="alert">
                        <div>
                            <i className="bi bi-exclamation-triangle-fill"></i> {' '}
                            <strong>Hết lượt xem SĐT hôm nay!</strong><br/>
                            <small>Vui lòng liên hệ Admin.</small>
                        </div>
                    </div>
                )}
            </div>
        )
    }

    const handleViewOldProperty = (phone) => {
        window.dispatchEvent(new CustomEvent('searchByPhone', { detail: phone }))
        onHide() // đóng modal
    }

    const handleTempDelete = async () => {
        try {
            await tempDeleteProperty({ id: property._id }).unwrap()
            toast.success(property.isTempDeleted ? 'Đã khôi phục!' : 'Đã đưa vào thùng rác!')
            onHide()
        } catch (err) {
            toast.error('Thao tác thất bại')
        } finally {
            setShowTempDeleteConfirm(false)
        }
    }

    const handleDelete = async () => {
        try {
            await deleteProperty({ id: property._id }).unwrap()
            toast.success('Xóa bất động sản thành công!')
            onHide()
        } catch (err) {
            console.error(err)
            toast.error(err?.data?.message || 'Xóa thất bại, vui lòng thử lại')
        } finally {
            setShowDeleteConfirm(false)
        }
    }

    return (
        <>
            <Modal show={show} onHide={onHide} size={mode === 'edit' ? 'xl' : 'lg'} centered backdrop="static">
                <Modal.Header closeButton className="bg-dark text-info border-bottom border-secondary" closeVariant="white">
                    <Modal.Title>
                        {mode === 'detail' ? (
                            <>
                                <i className="bi bi-house-door me-2"></i>
                                Chi tiết bất động sản
                            </>
                        ) : (
                            <>
                                <i className="bi bi-house-gear me-2"></i>
                                Chỉnh sửa bất động sản
                            </>
                        )}
                    </Modal.Title>
                </Modal.Header>

                {/* NỘI DUNG CHUYỂN ĐỔI THEO MODE */}
                {mode === 'detail' ? (
                    <Modal.Body className="bg-dark text-white">
                        {/* === NỘI DUNG CHI TIẾT (giống cũ) === */}
                        <div className="row">
                            <div className="col-md-6">
                                {property.images?.length > 0 ? (
                                    <Carousel>
                                        {property.images.map((img, i) => {
                                            const publicId = getPublicId(img);
                                            const fallbackUrl = img.url || null;
                                            return publicId ? (
                                                <Carousel.Item key={i}>
                                                    <CloudinaryImage
                                                        publicId={publicId}
                                                        width={400}
                                                        height={300}
                                                        crop="limit"
                                                        alt={`Ảnh ${i + 1}`}
                                                        className="d-block w-100 rounded"
                                                        style={{ maxHeight: '420px',background: '#000' ,objectFit: 'contain' }}
                                                        fallbackUrl={fallbackUrl}
                                                    />
                                                </Carousel.Item>
                                            ) : null;
                                        })}
                                    </Carousel>
                                ) : (
                                    <div className="bg-secondary rounded d-flex align-items-center justify-content-center" style={{ height: '420px' }}>
                                        <p className="text-white-50 fs-4 mb-0">Không có hình ảnh</p>
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6">
                                {/* <p className="mb-2">{renderPhones()}</p> */}
                                <div className="mb-2">
                                    {renderPhones()}
                                </div>
                                <p><strong>Chủ nhà:</strong> {property.ownerName || 'Chưa có'}</p>
                                <p><strong>Địa chỉ:</strong> {property.houseNumber} {property.street}, {property.oldWard} {property.oldDistrict} {property.newWard && `(P. ${property.newWard})`}</p>
                                <p><strong>Loại:</strong> {property.propertyType} - {property.position}</p>
                                <p><strong>Diện tích sàn:</strong> {property.floorArea || '?'}m² (ngang {property.width || '?'}m × dài {property.length || '?'}m)</p>
                                <p><strong>Tổng diện tích sàn:</strong> {property.totalArea || '?'}m²</p>
                                <p><strong>Số tầng:</strong> {property.floors || '?'}</p>
                                <p><span className="text-primary"><strong>Giá thuê:</strong> {(property.price || 0).toLocaleString()}đ/tháng</span></p>
                                {property.description && <p><strong>Mô tả:</strong> {property.description}</p>}
                                <div className="mt-2">
                                    {property.status === "Đang cho thuê" && (
                                        <span className="badge bg-primary text-white px-3 py-2">
                                            <i className="bi bi-house-door me-2"></i>
                                            Đang cho thuê
                                        </span>
                                    )}
                                    {property.status === "Đã cho thuê" && (
                                        <span className="badge bg-success text-white px-3 py-2">
                                            <i className="bi bi-check-circle me-2"></i>
                                            Đã cho thuê
                                        </span>
                                    )}
                                    {property.status === "Đã bán" && (
                                        <span className="badge bg-warning text-white px-3 py-2">
                                            <i className="bi bi-cart-check me-2"></i>
                                            Đã bán
                                        </span>
                                    )} {' '}
                                    {property.isTempDeleted ? (
                                        <span className="badge bg-danger text-white px-3 py-2">
                                            <i className="bi bi-trash3 me-2"></i>
                                            Đang tạm xóa
                                        </span>
                                    ) : (<></>)}
                                </div>

                                <div className="mt-4 pt-3 border-top border-secondary">
                                    {property.createdBy && (
                                        <small className="text-info d-block">
                                            Tạo bởi <strong>{property.createdBy}</strong> lúc {new Date(property.createdAt).toLocaleString('vi-VN')}
                                        </small>
                                    )}
                                    {property.updatedBy && (
                                        <small className="text-info d-block">
                                            Sửa lần cuối bởi <strong>{property.updatedBy}</strong> lúc {new Date(property.updatedAt).toLocaleString('vi-VN')}
                                        </small>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                ) : (
                    <PropertyEditForm
                        property={property}
                        onSuccess={() => setMode('detail')}
                        onCancel={() => setMode('detail')} 
                        onDuplicateFound={onDuplicateFound}
                        onViewOldProperty={handleViewOldProperty}
                    />
                )}

                {/* FOOTER – CHỈ HIỆN KHI Ở CHẾ ĐỘ CHI TIẾT */}
                {mode === 'detail' && (
                    <Modal.Footer className="bg-dark border-0">

                        {isAdmin && (
                            <>
                                <Button
                                    variant="secondary"
                                    className="ms-3"
                                    onClick={() => setShowLogModal(true)}
                                >
                                    <i className="bi bi-clock-history"></i>
                                    Nhật ký
                                </Button>
                            </>
                        )}

                        <Button
                            variant="warning"
                            className="ms-3"
                            onClick={() => setMode('edit')} 
                        >
                            Sửa
                        </Button>

                        {isAdmin && (
                            <>
                                <Button 
                                    variant={property.isTempDeleted ? "success" : "danger"}
                                    className="ms-3"
                                    onClick={() => setShowTempDeleteConfirm(true)}
                                    disabled={isTempDeleting}
                                >
                                    {isTempDeleting ? (
                                        <>Đang xóa...</>
                                    ) : (
                                        property.isTempDeleted ? 'Khôi phục' : 'Xóa'
                                    )}
                                </Button>

                                {property.isTempDeleted && (
                                    <Button 
                                        variant="danger" 
                                        className="ms-3"
                                        onClick={() => setShowDeleteConfirm(true)}
                                        disabled={isDeleting}
                                    >
                                        {isDeleting ? (
                                            <>Đang xóa...</>
                                        ) : (
                                            'Xóa vĩnh viễn'
                                        )}
                                    </Button>
                                )}
                            </>
                        )}
                    </Modal.Footer>
                )}
            </Modal>

            <Modal
                show={showLogModal}
                onHide={() => setShowLogModal(false)}
                size="xl"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton className="bg-dark text-white border-0">
                    <Modal.Title>
                        <i className="bi bi-clock-history me-2"></i>
                        Nhật ký hoạt động - {property?.houseNumber} {property?.street}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-dark text-white">
                    {logLoading || logFetching ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" variant="light" />
                        </div>
                    ) : logData?.logs?.length ? (
                        <div className="table-responsive">
                            <table className="table table-dark table-hover table-striped">
                                <thead>
                                    <tr>
                                        <th>Thời gian</th>
                                        <th>Hành động</th>
                                        <th>Người thực hiện</th>
                                        <th>Chi tiết</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {logData.logs.map((log) => (
                                        <tr key={log._id}>
                                            <td className="small">
                                                {new Date(log.createdAt).toLocaleString('vi-VN', {
                                                    dateStyle: 'medium',
                                                    timeStyle: 'short'
                                                })}
                                            </td>
                                            <td>
                                                <span className={`badge ${getActionBadgeClass(log.action)}`}>
                                                    {getActionDisplayName(log.action)}
                                                </span>
                                            </td>
                                            <td className="small">
                                                {log.username}
                                                {/* {log.user && <small className="text-muted d-block">ID: {log.user}</small>} */}
                                            </td>
                                            <td className="small">
                                                {renderLogDetails(log)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="text-center py-5 text-muted">Chưa có hoạt động nào với bất động sản này</p>
                    )}

                    {/* Phân trang */}
                    {logData?.pagination&& (
                        <>
                            <div className="d-flex justify-content-center align-items-center gap-2 mt-4 flex-wrap px-3">
                                <button
                                    className="btn btn-sm btn-outline-light"
                                    onClick={() => setLogPage(1)}
                                    disabled={logPage === 1}
                                >
                                    ‹‹ Đầu
                                </button>

                                <button
                                    className="btn btn-sm btn-outline-light"
                                    onClick={() => setLogPage(p => Math.max(1, p - 1))}
                                    disabled={logPage === 1}
                                >
                                    ‹ Trước
                                </button>

                                {/* Số trang thông minh */}
                                {(() => {
                                    const total = logData.pagination.pages
                                    const current = logPage
                                    const pages = []

                                    if (total <= 7) {
                                        for (let i = 1; i <= total; i++) pages.push(i)
                                    } else if (current <= 4) {
                                        pages.push(1, 2, 3, 4, 5, '...', total)
                                    } else if (current >= total - 3) {
                                        pages.push(1, '...', total - 4, total - 3, total - 2, total - 1, total)
                                    } else {
                                        pages.push(1, '...', current - 1, current, current + 1, '...', total)
                                    }

                                    return pages.map((p, idx) =>
                                        p === '...' ? (
                                            <span key={idx} className="px-3 text-light fw-bold">...</span>
                                        ) : (
                                            <button
                                                key={p}
                                                className={`btn btn-sm ${current === p ? 'btn-dark text-white' : 'btn-outline-light'}`}
                                                onClick={() => setLogPage(p)}
                                            >
                                                {p}
                                            </button>
                                        )
                                    )
                                })()}

                                <button
                                    className="btn btn-sm btn-outline-light"
                                    onClick={() => setLogPage(p => p + 1)}
                                    disabled={logPage >= logData.pagination.pages}
                                >
                                    Sau ›
                                </button>

                                <button
                                    className="btn btn-sm btn-outline-light"
                                    onClick={() => setLogPage(logData.pagination.pages)}
                                    disabled={logPage === logData.pagination.pages}
                                >
                                    Cuối ››
                                </button>
                            </div>

                            <div className="text-center mt-4">
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault()
                                        const input = e.target.elements.goToPage.value.trim()
                                        const target = parseInt(input, 10)
                                        if (target >= 1 && target <= logData.pagination.pages) {
                                            setLogPage(target)
                                        } else {
                                        }
                                        e.target.elements.goToPage.value = ''
                                    }}
                                    className="d-inline-flex align-items-center gap-2"
                                >
                                    <small className="text-light nowrap">Đi đến trang:</small>
                                    <input
                                        type="number"
                                        name="goToPage"
                                        min="1"
                                        max={logData.pagination.pages}
                                        placeholder={logPage}
                                        className="form-control form-control-sm"
                                        style={{ width: '80px' }}
                                        required
                                    />
                                    <button type="submit" className="btn btn-sm btn-primary">
                                        Đi
                                    </button>
                                </form>
                            </div>

                            {/* Thông tin tổng */}
                            <div className="text-center mt-3">
                                <small className="text-muted">
                                    Trang <strong>{logPage}</strong> / <strong>{logData.pagination.pages}</strong>
                                    {' '} (Tổng <strong>{logData.pagination.total}</strong> hoạt động)
                                </small>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>

            {showTempDeleteConfirm && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 1070 }}>
                    <div className="modal-dialog modal-dialog-centered modal-sm">
                        <div className={property.isTempDeleted ? "modal-content bg-dark text-white border border-success" : "modal-content bg-dark text-white border border-danger"}>
                            <div className="modal-body text-center py-5">
                                <i className={property.isTempDeleted ? "bi bi-repeat display-1 text-success" : "bi bi-trash3 display-1 text-danger"}></i>
                                <h5 className="mt-4">
                                    {property.isTempDeleted 
                                        ? 'Khôi phục bất động sản này?' 
                                        : 'Xóa bất động sản này?'
                                    }
                                </h5>
                                <div className="mt-4">
                                    <button 
                                        className="btn btn-secondary px-4 me-3"
                                        onClick={() => setShowTempDeleteConfirm(false)}
                                        disabled={isTempDeleting}
                                    >
                                        Hủy
                                    </button>
                                    <button 
                                        className={property.isTempDeleted ? "btn btn-success px-4" : "btn btn-danger px-4"}
                                        onClick={handleTempDelete}
                                        disabled={isTempDeleting}
                                    >
                                        {isTempDeleting ? 
                                            (property.isTempDeleted ? 'Đang khôi phục...' : 'Đang xóa...') : 
                                            (property.isTempDeleted ? 'Khôi phục' : 'Xóa')
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            
            {showDeleteConfirm && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 1070 }}>
                    <div className="modal-dialog modal-dialog-centered modal-sm">
                        <div className="modal-content bg-dark text-white border border-danger">
                            <div className="modal-body text-center py-5">
                                <i className="bi bi-trash3 display-1 text-danger"></i>
                                <h5 className="mt-4">Xóa bất động sản này?</h5>
                                <p className="text-white">Hành động này <strong>không thể hoàn tác</strong></p>
                                <div className="mt-4">
                                    <button 
                                        className="btn btn-secondary px-4 me-3"
                                        onClick={() => setShowDeleteConfirm(false)}
                                        disabled={isDeleting}
                                    >
                                        Hủy
                                    </button>
                                    <button 
                                        className="btn btn-danger px-4"
                                        onClick={handleDelete}
                                        disabled={isDeleting}
                                    >
                                        {isDeleting ? 'Đang xóa...' : 'Xóa vĩnh viễn'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default PropertyModal